module.exports = __webpack_public_path__ + "static/img/login_bg.9a67e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_bg.png
// module id = ikPi
// module chunks = 1